export default "__VITE_ASSET__zzFCa4Nw__"